import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import IconButton from '../IconButton/IconButton.js';

const QuantitySelector = (props)=>{
    const { quantity , onDecreaseQuantity , onIncreaseQuantity , minimumQuantity =1 , maximumQuantity , isDisabled =false ,  } = props;
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "quantity-selector",
        "data-t": props['data-t']
    }, /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": getLabel('cart.item.quantity.decrement'),
        className: "quantity-selector__button quantity-selector__button--minus",
        disabled: quantity === minimumQuantity || isDisabled,
        onClick: onDecreaseQuantity
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "minus"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "quantity-selector__amount"
    }, quantity), /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": getLabel('cart.item.quantity.increment'),
        className: "quantity-selector__button quantity-selector__button--plus",
        disabled: maximumQuantity && quantity >= maximumQuantity || isDisabled,
        onClick: onIncreaseQuantity
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "plus"
    })));
};
var QuantitySelector$1 = QuantitySelector;

export { QuantitySelector$1 as default };
//# sourceMappingURL=QuantitySelector.js.map
